import { appRoute } from "routes/app/home.runtime"
import Schedules from "routes/schedule/schedules"
import { Plan } from "routes/plan/plan"
import { PlanToolbar, RegimeToolbar, TreeToolbar } from "slot-definitions"
import { ViewPlanButton } from "routes/plan/view-plan-button"
import { TaskActions } from "routes/plan/taskActions"
import { isInRegime } from "routes/facilities/lib/when-parent-item"
import { Stack } from "@mui/material"
import { If } from "lib/@components/switch"
import { registerFeature } from "lib/features"
import {
    FEATURE_FLAG_CALENDAR_VIEW,
    FEATURE_FLAG_GRID_VIEW,
    FEATURE_FLAG_PLANNING,
    FEATURE_FLAG_WEEK_VIEW,
} from "routes/plan/feature-flags.mjs"

registerFeature({
    numericalId: 5,
    name: "Planning",
    id: FEATURE_FLAG_PLANNING,
    description: "Show planning and conformity screens.",
})

registerFeature({
    numericalId: 2000,
    name: "Calendar Plan View",
    id: FEATURE_FLAG_CALENDAR_VIEW,
    description: "The calendar view of a plan",
    internalUseOnly: true,
})

registerFeature({
    numericalId: 2001,
    name: "Week Plan View",
    id: FEATURE_FLAG_WEEK_VIEW,
    description: "The week view of a plan",
    internalUseOnly: true,
})

registerFeature({
    numericalId: 2002,
    name: "Grid Plan View",
    id: FEATURE_FLAG_GRID_VIEW,
    description: "The grid view of a plan",
    internalUseOnly: true,
})

TreeToolbar("*").plug(
    <If
        if={isInRegime}
        field="inMenu"
        then={<RegimeToolbar.Slot />}
        else={
            <Stack direction="row" priority={2000} ml={2} mr={2} alignItems="center" spacing={2}>
                <RegimeToolbar.Slot />
            </Stack>
        }
    />
)
RegimeToolbar.plug(<ViewPlanButton priority={40} if={(c) => isInRegime(c) && !c.isRegimeDraftLocked} />)
PlanToolbar.plug(<TaskActions priority={40} />)

appRoute.register(
    "plan/:id",
    <Schedules>
        <Plan $lazy />
    </Schedules>
)
